$(document).on('click', 'body', (event) => {
  const extraareas = $('[data-add-cart-extraarea]').not($(event.target).closest('[data-add-cart-extraarea]'));
  extraareas.find('input[type="checkbox"]').prop('checked', false);
});
